import React from 'react';
import NmcContent from '../../layout/NmcContent';
import PageLayout from '../../layout/PageLayout';

const NmcContentPage = () => (
  <PageLayout>
    <NmcContent />
  </PageLayout>
);

export default NmcContentPage;
